<template>
  <div class="layout--full-page fullscreenDashboard" :style="{'background' : navbarColor}">
    <dark-navbar />
    <router-view></router-view>
  </div>
</template>
<script>
import DarkNavbar from './components/DarkNavbar.vue'

export default {
  components: {
    DarkNavbar,
  },
  data: function () {
    return {
      navbarColor:'#151D2F',
    }
  },
}
</script>
<style>
  
::-webkit-scrollbar {
  width: 0px;
}
</style>
